export const siteSettings = {
  name: 'Acemepros',
  link: 'https://acemepros.com',
  email: 'support@acemepros.com',
  appLink: 'https://app.acemepros.com',
};
